import { render, staticRenderFns } from "./entity-document-preview.vue?vue&type=template&id=c0f46586"
import script from "./entity-document-preview.vue?vue&type=script&lang=js"
export * from "./entity-document-preview.vue?vue&type=script&lang=js"
import style0 from "./entity-document-preview.vue?vue&type=style&index=0&id=c0f46586&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports